import { Link } from 'react-router-dom'
import React, {useContext, useEffect, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../services/api'
import { DataTableOptions } from '../../components/dataTableOptions'
import {MainContext} from "../../context/MainContext";
import {AuthContext} from "../../context/AuthContext";
import {useNavigate} from "react-router";
import Swal from "sweetalert2";
import Async from "react-select/async";
import dayjs from "dayjs";

export default function ListingWeapons() {
  const navigate = useNavigate();
  const {setPageTitle, setLoading} = useContext(MainContext)
  const { authUser, isAthlete } = useContext(AuthContext)

  const [active, setActive] = useState<boolean>(true);
  const [weapon, setWeapon] = useState<any>([])

  const INITIAL_DATA = {
    value: 0,
    label: 'Selecione o Sócio',
  };

  const [athlete, setAthlete] = useState(INITIAL_DATA);

  const getWeapons = async () => {
    setLoading(true)
    let athleteSelected = !isAthlete && athlete.value != 0;
    let athleteID = athleteSelected ? "/"+athlete.value: ""

    if(athleteSelected || isAthlete){
      await api.post('/api/weapons/my' + athleteID, {active}).then((response) => {
        setWeapon(response.data)
      })
    }
    setLoading(false)
  }

  async function socios(value = '') {
    const response = await api.get(`/api/athletes/getToSelect/?search=${value}`)
    const result = await response
    return await result.data.map((athlete:any) => ({
      label: `${athlete.member_number || ""} - ${(['coordinator', 'admin'].includes(authUser?.role) ? athlete.full_name : athlete.full_name_abv)}`,
      validities: athlete.cr_validity_date,
      value: athlete.id
    }))
  }

  async function setSocios(data:any) {
    try {
      if (dayjs(data.validities).diff(dayjs(), 'day') < 0) {
        await Swal.fire({
          title: 'Atenção!',
          text: "Atirador com CR Vencido!",
          icon: 'warning',
          allowOutsideClick: false,
        })
      }

      setLoading(true)
      setAthlete(data);
      setLoading(false)

    }catch (err: any) {
      setLoading(false)
      await Swal.fire({
        title: 'Erro!',
        text: err,
        icon: 'error',
      })
    }finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getWeapons()
  }, [active, athlete])

  useEffect(() => {
    setLoading(true)
    setPageTitle(isAthlete ? "Meu Acervo": "Acervos")

    if (isAthlete ){
      if (!authUser?.athlete?.cr_number || !authUser?.athlete?.cr_expedition_date || !authUser?.athlete?.cr_validity_date){
        setLoading(false)
        Swal.fire({
          title: 'Atenção!',
          text: "Informações do CR devem ser informadas no seu perfil!",
          icon: 'warning',
        }).then(()=> {
          return navigate("/profile");
        })
      }

      const fetchData = async () => {
        await getWeapons()
      };

      fetchData().then(setLoading(false))
    }else{
      setLoading(false)
    }
  }, [])

  const columns: any = [
    {
      name: 'description', label: 'Modelo', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'active', label: 'Ativa', options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (index: string | number) => {
          const statusColor = weapon[index]?.active ? 'success' : 'danger';
          const statusText = weapon[index]?.active?'Ativa':'Inativa';
          return (
              <span className={`badge rounded-pill bg-${statusColor}-subtle border-${statusColor}-subtle text-${statusColor}-emphasis`}>
                  &nbsp;{statusText}&nbsp;
              </span>
        )},
      },
    },
    {
      name: 'sigma_number', label: 'Nº sigma', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'serial_number', label: 'Nº serie', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: '', label: '', options: {
        filter: false,
        false: true,
        customBodyRenderLite: (index: string | number) => {return (
              <Link className='btn btn-sm btn-warning' to={`/weapons/update/${weapon[index]?.id}`} title="Editar"><i className="bi bi-pencil" aria-hidden="true"></i> </Link>
          )
        },
      },
    },
  ]

  const options: any = DataTableOptions

  return (
    <>
    {(!isAthlete) &&
        <>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Sócio</h5>

              <div className="col-md-6">
                <Async
                    name="search"
                    autoFocus={false}
                    isLoading={false}
                    cacheOptions
                    loadOptions={socios}
                    noOptionsMessage={() => "Nenhum registro encontrado"}
                    onChange={(data: any) => {
                      setSocios(data).then(setLoading(false))
                    }}
                    value={athlete}
                    defaultOptions
                />
              </div>

            </div>
          </div>
        </div>
      </>
    }

      {(isAthlete || athlete.value != 0) &&
        <>
          <div className='mb-4'>
            <Link className='btn btn-success mb-3' to='/weapons/create' state={{ athlete }}><i
                className="bi bi-plus-circle">&nbsp;</i> Cadastrar Arma</Link>

            <div className="col-md-12 mb-2">
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" id="active"
                       onChange={evento => setActive(evento.target.checked)}
                       checked={active}/>
                <label className="form-check-label"
                       htmlFor="active">{`Mostrando armas ${active ? ' ativas' : ' inativas'}`} </label>
              </div>
            </div>

            <MUIDataTable
                title={''}
                data={weapon}
                columns={columns}
                options={options}
            />
          </div>

        </>
      }
    </>
  )
}
